module.exports = __webpack_public_path__ + "64560cda9b30c038c154e0719cdb2318.glb";